<template>
  <section>
    <a-card :title="channelFansData.title" :bordered="false" @back="$emit('back-to-page')">
      <template #extra>
        <a-button @click="$emit('back-to-page')">返回</a-button>
      </template>
    </a-card>
    <div class="ant-pro-table-search">
      <a-form :form="queryParam" v-bind="searchFormLayout" @keydown.enter.native="reloadTable">
        <a-row :gutter="16">
          <a-col :xl="6" :md="8" :sm="12" :xs="24">
            <a-form-item label="联系人">
              <a-input v-model="queryParam.friendWhatsId" />
            </a-form-item>
          </a-col>
          <a-col :xl="6" :md="8" :sm="12" :xs="24">
            <a-form-item label="地区">
              <SelectCountry v-model="queryParam.countryCode" />
            </a-form-item>
          </a-col>
          <a-col :xl="6" :md="8" :sm="12" :xs="24">
            <a-form-item label="客服号">
              <a-input v-model="queryParam.whatsId" />
            </a-form-item>
          </a-col>
          <a-col :xl="6" :md="8" :sm="12" :xs="24">
            <a-form-item label="进粉时间">
              <a-range-picker
                v-model="queryParam.joinFanTime"
                :show-time="{
                  hideDisabledOptions: true,
                  defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                }"
                @change="(_, dateString) => onChangeTime(dateString, 'startCreateTime', 'endCreateTime')"
              />
            </a-form-item>
          </a-col>
          <a-col :xl="6" :md="8" :sm="12" :xs="24" class="table-page-search-wrapper">
            <div class="table-page-search-submitButtons">
              <a-space>
                <a-button type="primary" @click="reloadTable"> 查询 </a-button>
                <a-button @click="resetSearchForm"> 重置 </a-button>
              </a-space>
            </div>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-card :bordered="false" :body-style="{ padding: 0 }">
      <div class="ant-pro-table-toolbar" style="justify-content: flex-end">
        <div class="ant-pro-table-toolbar-option">
          <a-button type="primary" :loading="exportLoading" @click="handleExport"> 导出 </a-button>
        </div>
      </div>
      <a-table
        :row-key="rowKey"
        :columns="columns"
        size="middle"
        :data-source="dataSource"
        :loading="loading"
        :pagination="pagination"
        :scroll="{ x: 1200, y: tabHeight }"
        @change="handleTableChange"
      />
    </a-card>
  </section>
</template>

<script>
import { TablePageMixin } from '@/mixins'
import SelectCountry from '@/components/SelectCountry'
import { exportFiles } from '@/utils/util'

export default {
  components: { SelectCountry },
  mixins: [TablePageMixin],
  props: {
    channelFansData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {}
  },
  computed: {
    columns() {
      return [
        {
          title: '联系人',
          dataIndex: 'friendWhatsId',
          scopedSlots: { customRender: 'friendWhatsId-slot' },
          align: 'center',
          width: 160
        },
        {
          title: '昵称',
          dataIndex: 'nickname',
          align: 'center',
          width: 100,
          ellipsis: true
        },
        {
          title: '地区',
          dataIndex: 'countryCode',
          align: 'center',
          width: 100,
          ellipsis: true
        },
        {
          title: '客服号',
          dataIndex: 'whatsId',
          scopedSlots: { customRender: 'whatsId-slot' },
          align: 'center',
          width: 160
        },
        {
          title: '进粉时间',
          dataIndex: 'createTime',
          align: 'center',
          width: 170
        }
      ]
    }
  },
  created() {
    this.getPage = this.channelFansData.getPage
  },
  methods: {
    handleExport() {
      this.exportLoading = true
      exportFiles({
        request: this.channelFansData.exportFunction,
        queryParam: {
          ...this.channelFansData.exportParams,
          ...this.queryParam
        },
        fileName: this.channelFansData.title + '.xlsx',
        callback: () => {
          this.exportLoading = false
        }
      })
    }
  }
}
</script>

<style lang="less" scoped></style>
